import { PrescriptionPackage as PrescriptionPackageApi } from '@dreryk/egabinet-prescription-frontend-api';

import { PrescriptionPackage, UnsentPrescriptionPackage } from '../types';

export const isUnsentPrescriptionPackage = (
   prescriptionPackage: PrescriptionPackage | PrescriptionPackageApi
): prescriptionPackage is UnsentPrescriptionPackage => {
   return prescriptionPackage.packageStatus === 'CREATED' || prescriptionPackage.packageStatus === 'ERROR';
};
